<div class="bg-(--toolbar-color) text-(--toolbar-text-color)">
    <div class="w-6xl flex flex-row items-center mx-auto space-x-4 h-[50px]">
        <span i18n class="text-base"> Sort By: </span>
        <mat-button-toggle-group i18n-aria-label aria-label="Sort projects" [value]="sortBy()"
            (change)="sortBy.set($event.value)" hideSingleSelectionIndicator>
            <mat-button-toggle value="created"> <span i18n>Date Created</span> </mat-button-toggle>
            <mat-button-toggle value="name"> <span i18n>Name</span> </mat-button-toggle>
            <mat-button-toggle value="participant">
                <span i18n>Participant Count</span>
            </mat-button-toggle>
            <mat-button-toggle value="completed"> <span i18n>Completed Count</span> </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-button-toggle-group i18n-aria-label aria-label="Sort order" [value]="sortDirection()"
            (change)="sortDirection.set($event.value)" hideSingleSelectionIndicator>
            <mat-button-toggle value="desc" i18n-aria-label aria-label="Descending">
                <mat-icon aria-hidden="true">arrow_downward</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="asc" i18n-aria-label aria-label="Ascending">
                <mat-icon aria-hidden="true">arrow_upward</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
        <span class="flex-grow"></span>
        <a matButton="filled" i18n-aria-label aria-label="New Project" [routerLink]="['new-project']"
            [state]="{ showLoading: false }">
            <mat-icon>add</mat-icon> <span i18n>New Project</span>
        </a>
    </div>
</div>

<div class="grid auto-rows-min grid-cols-3 gap-x-6 gap-y-[30px] w-6xl mx-auto my-[25px] text-(--body-text-color)">
    @for(card of sortedProjects(); track card.id) {
    <a [routerLink]="['projects', card.id]">
        <div id="{{ card.id }}"
            class="max-h-[125px] grid grid-cols-2 auto-rows-auto p-4 shadow-[2px_2px_5px_lightgrey] border-l-10 border-l-(--inactive-color) min-h-[125px]"
            [class.complete]="card.isActive">
            <span class="text-sm italic col-span-2" title="{{ card.createdLabel }}">{{
                card.createdLabel
                }}</span>
            <span class="text-2xl col-span-2 font-semibold text-nowrap text-ellipsis overflow-hidden self-stretch"
                title="{{ card.name }}">{{ card.name }}</span>
            <span class="text-sm col-span-1 self-end justify-self-start font-medium" i18n="@@participantsLabel">{{
                card.participant }} Participants</span>
            <span class="text-sm col-span-1 self-end justify-self-end font-medium" i18n="@@completedLabel">{{
                card.completed
                }}
                Completed</span>
        </div>
    </a>
    }
</div>
<router-outlet></router-outlet>